import { config } from '@config'
import { DefaultConfig } from '@constants'

export const strings_en = {
  zone: 'zone',
  zones: 'zones',
  activity: 'activity',
  drop: 'drop',
  important: 'Important',
  zoneRestriction: 'zoneRestriction',
  cluster: 'cluster',
  clusters: 'clusters',
  Cluster: 'Cluster',
  store: 'store',
  global: 'global',
  channels: 'channels',
  client: 'Client',
  freeTags: 'free tags',
  salesPeriods: 'salesPeriods',
  sortBySalesPeriod: 'salesPeriod',
  sortByFavourites: 'favourites',
  sortByAttributes: 'attribute',
  sortByGlobalGroup: 'global',
  sortByProductAttributesGroup: 'product_attributes',
  sortByBuyValue: 'buyValue',
  sortByBuyQty: 'buyQuantity',
  coreStatus: 'CORE',
  seasonSync: 'seasonsync',
  activities: 'activities',
  assortmentReviewTypes: {
    SUGGESTION: 'Review requested'
  },
  imageType: {
    activityImage: 'Activity Image',
    collectionImage: 'Collection Iamge'
  },
  assortmentReviewStatus: {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
  },
  currencyCode: config.globalCurrency || DefaultConfig.GLOBAL_CURRENCY,
  buyingSessionPreBuying: 'PRE_BUYING',
  storesSettings: 'Stores',
  storeClusterSettings: 'Clustering',
  storeOTBSettings: 'OTB Weight',
  Admin: 'VIP Administrator Role',
  GlobalMerchaniser: 'Central Merchandiser Retail Role',
  RegionalMerchandiser: 'Regional Merchandiser Role',
  wholeSaleChannelName: 'Wholesale',
  retailChannelName: 'Retail',
  productStatus: {
    CORE: 'CORE',
    NON_CORE: 'NON_CORE'
  },
  restrictedProductWarning: 'Product Inaccessible',
  lookName: 'Look Name',
  lookFilter: 'Look Filter',
  lookComposition: 'Composition',
  lookColor: 'Color',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  recommended: 'Reco',
  booked: 'Booked',
  book: 'Book',
  bookUnbookAllWarningMessage: 'All quantities will be set to 0',
  bookAll: 'Book All',
  unbookAll: 'Un-book All',
  multiple: 'MULTIPLE',
  pointer: 'pointer',
  closed: 'CLOSED',
  pause: 'PAUSE',
  sentToSAP: 'Sent to SAP',
  excelMimeType:
    'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  blanks: '(Blanks)',

  //Card labels
  colorSpecification: 'COLOR',
  retailClusters: 'Retail clusters',
  salesPeriod: 'Sales Period',
  retailPrice: 'Retail Price',
  substitutesInLooks: 'Substitutes In Looks',
  retailPriceInZone: 'Price In Zone',
  retailPriceInEUR: 'Price In EUR',
  retailPriceInUSD: 'Price In USD',
  retailCMClusters: 'CM Clusters',
  retailColor: 'Color',
  retailStatus: 'Retail Status',
  retailComposition: 'Composition',
  retailFloorDisplayWeek: 'Floor Display Week',

  //Attribute Selection labels
  channel: 'channel',
  channelsForAttributeSelection: 'Channels',
  zonesForRestriction: 'Zones for restriction',

  maxAttributeMessage: 'Select all attributes to be shown on card (Max 10)',
  yes: 'Yes',
  no: 'No',
  confirm: 'Confirm',

  //channel
  removeChannel: 'Remove Channel',
  addChannel: 'Add Channel',
  removeChannelMessageForPreBuyingSession:
    'Removing retail channel will also remove product from cluster, zone and store assortments. Are you sure you want to continue?',
  removeChannelMessageForBuyingOrFrozenSession:
    'Removing retail channel will remove product from cluster assortment. Are you sure you want to continue?',
  bulkRemoveChannelMessageForPreBuyingSession:
    "<font color='#ffab07'>*Bulk removal of channel will not affect core products in buying session. </font><br><br>Removing retail channel will also remove product from cluster, zone and store assortments. Are you sure you want to continue?",
  bulkAddConfirmationModalHelpText:
    'Note : Bulk removal of channel will not affect core products in buying session',
  bulkAddChannelMessageForPreBuyingSession: 'Are you sure you want to continue?',

  // Notification priority
  notificationHigh: 'HIGH',
  notificationNormal: 'NORMAL',
  notificationLow: 'LOW',

  notifications: 'Notifications',

  worldWide: 'Worldwide',
  worldWideReport: 'Worldwide Report',
  zoneReport: 'Zone Report',
  storeReport: 'Store Report',
  betReport: 'Bet Report',

  commentsHelpText: 'Click here to add comment',
  noSettingsMessage: 'No settings available',
  noSeasonsMessage: 'No seasons available',

  //Views
  cardView: 'CARD',
  listView: 'LIST',
  kpiView: 'KPIs',
  collection: 'COLLECTION',

  grid: 'grid',
  list: 'list',
  kpi: 'kpi',

  // PDF export
  exportToPDF: 'Export To PDF',

  // Tooltips
  toolTipToggleFilter: 'Toggle Filter',
  toolTipReviewAssortment: 'Review Assortment',
  toolTipRequestApproval: 'Request for Review',
  toolTipAddProduct: 'Add Product',
  toolTipSortProduct: 'Sort Product',
  toolTipGridView: 'Grid View',
  toolTipCardView: 'Card',
  toolTipListView: 'List',
  toolTipExportExcel: 'Export To Excel',
  toolTipRetailExportExcel: 'Export Retail Collection To Excel',
  toolTipManageFilters: 'Manage Filters',
  listViewInputField: 'list-view-input-field',

  rightNavigation: 'Right Navigation',
  manageAttributes: 'Manage Attributes',
  splitQuantity: 'Split Quantity',

  //Buyingsession toolbar
  report: 'Report',
  buyingOverview: 'Buying Overview',
  buyingDocuments: 'Buying Documents',
  uploadBriefDialogTitle: 'Upload Buying Documents PDF',
  errorMsgFailedToUploadDoc: 'Failed to upload document: Please select file.',

  // API errors
  errorMsgForFailedToUpdate: 'Failed to update',

  // API Error codes
  buyingSessionErrors: 'BUYING_SESSION_ERROR',
  associationChangeErrors: 'ASSOCIATION_CHANGE_FOR_SAME_ZONE_ERROR',

  // Default look attribute names
  lookProductColor: 'Color',
  lookProductRetailStatus: 'Retail Status',
  lookProductCategory: 'Category',
  lookProductSubCategory: 'Sub Category',
  lookProductLining: 'Type',

  // Zone currency change confirmation msg
  zoneCurrencyChangeConfirmationMsg:
    'This change will update currency for selected combination. Once updated, it will not be possible to change currency for next one hour. Do you want to continue?',

  //Main Reporting CM Tabs label
  mainReportingWorldWideBuyTab: 'WORLDWIDE BUY',
  mainReportingZoneBuyTab: 'ZONE BUY',
  mainReportingBetTab: 'BET',

  //Main Reporting RM Tabs label
  mainReportingZoneTab: 'ZONE',
  mainReportingStoresTab: 'STORES',

  // Error messages
  authenticationError: 'User is not Authenticated',
  c8GraphQLSessionExpiredError: 'The client session has expired or is invalid.',

  centricCallSuccess: 'Successful',

  //Remove Last RM cluster conformation message
  removeLastRmClusterConfirmationMessage:
    'The action you are trying to perform will delete the product from zone assortment. Do you want to continue ?',

  //Constants for Size attributes of BuyingSessionProduct
  buyingSessionProductSizeAttribute: {
    sizeFrom: 'sizeFrom',
    sizeTo: 'sizeTo'
  },

  add: 'Add',
  remove: 'Remove',

  // Collection view products error popup
  notAllowed: 'Not Allowed',
  cannotAddClusterToNonRetailProduct:
    'Cannot add Retail Cluster to product as it is not in Retail Channel',
  cannotAddRetailToInactiveProduct: 'Cannot add Retail channel on inactive product',

  // Group settings
  sortOrderForGenderName: ['MEN', 'WOMEN', 'UNISEX', 'KIDS'],

  // Wholesale cluster
  commonConfirmatioinToDelete: 'Are you sure you want to delete?',
  deleteCluster: 'Delete Cluster',
  deleteClusterGroup: 'Delete Cluster Group',
  deleteClusterStatus: 'Delete Status',
  clusterStatus: 'Cluster Status',
  addCluster: 'Add Cluster',
  addStatus: 'Add Status',
  createClusterHeaders: [
    { key: 'clusterName', value: 'Cluster Name' },
    { key: 'color', value: 'Color' },
    { key: '', value: '' }, // actions don't have header name
    { key: 'clusterOrder', value: 'Cluster Order' } // epmty string added as a placeholder for action column
  ],
  createClusterGroupHeaders: [
    { key: 'clusterGroupName', value: 'Cluster Group Name' },
    { key: 'clusterGroupOrder', value: 'Cluster Group Order' },
    { key: '', value: '' } // actions don't have header name
  ],
  createClusterStatusHeaders: [{ key: 'clusterStatuses', value: 'Cluster Statuses' }],

  //wholesale Product Grid titles
  wholesalePrice: 'Wholesale Price',

  defaultTabAttributeSelection: 'product_attributes',

  //price labels
  priceLabels: {
    srp: 'SRP',
    localSrp: 'Local SRP',
    euroPrice: 'Euro Price'
  },

  //Tag Types
  tagTypes: {
    channel: 'channel',
    cluster: 'cluster',
    drop: 'drop',
    freeTag: 'freeTag',
    wholesaleFreeTags: 'wholesaleFreeTags',
    retailFreeTags: 'retailFreeTags',
    wholesaleCluster: 'wholesaleCluster',
    retailCluster: 'retailCluster',
    salesPeriod: 'salesPeriod',
    clientExclusions: 'clientExclusions',
    zoneExclusions: 'zoneExclusions',
    wholesaleClusterExclusions: 'wholesaleClusterExclusions',
    retailClusterExclusions: 'retailClusterExclusions'
  },

  //Export order options
  exportAllOrders: 'Export All Orders',
  exportSelectedOrders: 'Export Selected Orders',

  mutationResultSuccess: 'SUCCESS',
  sapSuccess: 'Success',

  Drops: 'Drops',
  Channels: 'Channels',

  //Showroom quantity types
  totalTargetQuantity: 'Total Draft Quantity',
  totalSizedQuantity: 'Total Sized Quantity',

  // deprecated
  showroomHeaders: {
    showroomSubHeaderFilterValues: {
      allProducts: 'allProducts',
      recommendedProducts: 'Reco Products'
    }
  },

  // deprecated
  unbookedConfirmationMessage:
    'Are you sure you want to unbook this product? This action will remove draft and sized quantities.',
  removeProductFromBasket:
    'Are you sure you want to delete this product? This action will remove draft and sized quantities on all doors',
  targetQuantity: `Draft Quantity`,
  sizedQuantity: `Sized Quantity`,
  singleSizeProduct: 'Single Size Product',
  singleQuantity: 'Quantity',

  // Status change warnings
  bulkStatusChange: {
    ordersWithoutQty: 'Non booked ACs or booked ACs without quantity will be deleted'
  },
  statusChangeWarning: `Warning, non booked ACs and booked ACs without quantity will be deleted.`,
  exportExcelError: {
    title: 'Export Excel Error',
    userLimit:
      'Currently Server is busy with many requests. Please try later or try exporting without images.',
    rowLimit: `Selected excel export crosses the max row limit of ${
      process.env.VIP_EXCEL_MAX_ROW_COUNT_ALLOWED_WITH_IMAGES || 20000
    }. Please try exporting without images.`
  },
  blankCellHelpText: {
    Notes: 'Add notes',
    DeliveryDate: 'Add Delivery Date',
    notes: 'Add notes',
    poRef: 'Add Client PO Ref',
    deliveryDate: 'Add Delivery Date'
  },
  genericError: 'Something went wrong',
  // Send to sap errors
  exportFailedForInvalidOrders: `Either order is not validated or not a master order`,
  bulkExportFailedForInvalidOrders: `Failed to send following orders to SAP. They are either not validated or not master order: `,
  failedToSendSapOrders: `Failed to send following orders to SAP`,

  //order setting bulk operation pop up
  emptyOrderValidationErrorMessageForBulkUpdate: `Following orders do not have any products and therefore, their status cannot be changed to "Confirmed". Please unselect them and try again.`,
  bulkOrderValidationPopupDescription:
    'Status for below orders cannot be changed due to below errors',

  // CM/ZAM filter
  filterOptionsLabels: {
    salesQty: {
      with: 'With Qty',
      without: 'Without Qty'
    },
    status: {
      with: 'Active',
      without: 'Inactive'
    },
    favourite: {
      with: 'Favourite',
      without: 'Unfavourite'
    },
    rating: {
      with: 'Rated',
      without: 'Unrated'
    },
    productStatus: {
      with: 'Core',
      without: 'Non Core'
    },
    hasCounterOffer: {
      with: 'Flagged',
      without: 'Unflagged'
    },
    productOrderStatus: {
      with: 'Order Product',
      without: 'Non Order Product'
    },
    productComment: {
      with: 'CM',
      without: 'RM'
    }
  },

  // Select all
  selectAllLimitMsg: 'Cannot select more than $$MAX_SELECTION_LIMIT$$ records.',

  // Order status change
  canNotChageOrderStatus:
    'Cannot change order status as either client / door is inactive',
  cannotChangeStatusAsProductsAreInactive:
    'Cannot change order status as it either has inactive product or deactivated size with quantity',

  // Send to SAP
  cannotSendOrderToSAPAsParentIsInactive:
    'Cannot send order to SAP as either client / door is inactive',
  cannotChangeSendOrderToSAPAsProductsAreInactive:
    'Cannot send order to SAP as it either has inactive product or deactivated size with quantity',

  // offline error message,
  offlineToasterMessage: 'You are offline. Please check your internet connection.',

  //Door and Activity Selection PopOver
  createNewOrder: 'Create New Order',

  presentationCustomizedPage: 'Customized Page',
  presentationEmbeddedPage: 'Embedded Page',
  presentationTableNameColumnLabel: 'NAME',
  presentationTableNameClientLabel: 'CLIENTS',
  presentationTableNameActionsLabel: 'ACTIONS',
  presentationTableNameDateLabel: 'DATE',
  presentationNameAlreadyTaken: 'Presentation Name already taken',

  // Customer Portal product detail
  sizes: 'Sizes',
  buyingSessionsEntity: 'buyingSessions',
  notAvailable: '-',
  ellipsis: '...',
  // on forgot password
  emailSuccess: 'An email with reset password instructions has been sent',
  // Customer Portal product media
  mediaAlt: 'Product Media',

  productSourceOrderCreationOptions: [
    { id: 'empty', label: 'Empty order' },
    { id: 'recommended', label: 'Add CM recommended products automatically' }
  ],
  //new order ui
  door: 'DOOR',
  discountSyncFailed: 'Discount sync has failed, Please consider manual syncing',
  orderValidationErrorKeys: {
    inactiveProducts: 'Inactive Products',
    clientExcludedProducts: 'Client Excluded Products',
    zoneExcludedProducts: 'Zone Excluded Products',
    withoutWHLChannelProducts: 'Products without Wholesale Channel',
    withoutRTLChannelProducts: 'Products without Retail Channel',
    inactiveSizeProducts: 'Inactive Size Products',
    clusterExcludedProducts: 'Cluster Excluded Products'
  },
  // retail settings
  retailStoreModal: 'retailStoreModal'
}
